import { LowerCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { StripeSubscriptionEventDto } from '@workspace/data-types';
import {
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
  SimpleChipComponent,
} from '@workspace/ng-aura';
import { StripeSubscriptionEventColumnKey } from './abstract-stripe-subscription-events-data-table.component';
import { StripeSubscriptionEventsDataTableFilterCoreComponent } from './filter/stripe-subscription-events-data-table-filter.component';

@Component({
  selector: 'core-stripe-subscription-events-data-table',
  templateUrl: './stripe-subscription-events-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    LowerCasePipe,
    MatIconModule,
    MatTooltipModule,
    StripeSubscriptionEventsDataTableFilterCoreComponent,
    RouterModule,
    SimpleChipComponent,
  ],
})
export class StripeSubscriptionEventsDataTableCoreComponent extends BaseDataTableCoreComponent<
  StripeSubscriptionEventDto,
  StripeSubscriptionEventColumnKey
> {}
